import React from 'react';
import PropTypes from 'prop-types';
import css from './BlogListing.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import { H4 } from '../Heading/Heading';
import NamedLink from '../NamedLink/NamedLink';

const MAX_TITLE_LEN = 60;
const MAX_DESC_LEN = 100;

function truncate(str, n) {
  if (!str) return '';
  return str.length > n ? str.slice(0, n - 1) + '…' : str;
}

const BlogListing = ({ blogs, fetchBlogsInProgress, fetchBlogsError }) => {
  if (fetchBlogsInProgress) {
    return <div className={css.loading}>Loading blog highlights…</div>;
  }
  // Because old listings don't have blogs, we return null if blogs is empty
  // if (fetchBlogsError) {
  //   return <div className={css.error}>Could not load blog highlights.</div>;
  // }
  if (!blogs || blogs.length === 0) return null;

  return (
    <>
      <H4 className={css.itemTitle}>Blog Highlights for This Listing</H4>
      <p className={css.itemSubTitle}>
        Relevant posts created by the owner to help you decide, use, and care for this item.
      </p>

      <div className={css.blogItems}>
        <Swiper
          spaceBetween={24}
          slidesPerView={3}
          navigation
          modules={[Navigation]}
          style={{ padding: '8px 0' }}
          breakpoints={{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          cssMode={true}
        >
          {blogs.map(blog => {
            const blogId = blog._id || blog.id;
            const listingId = blog.listingId;
            const imageUrl = blog.image?.imageUrl || blog.image?.secure_url;
            const title = truncate(blog.title, MAX_TITLE_LEN);
            const tag = blog.label || '';
            const desc = truncate(blog.content?.excerpt || blog.content?.description || '', MAX_DESC_LEN);

            return (
              <SwiperSlide key={blogId}>
                <NamedLink
                  name="BlogContentPage"
                  params={{ blogId, listingId }}
                  className={css.blogLink}
                >
                  <div className={css.blogCard}>
                    {imageUrl && (
                      <img
                        className={css.blogCardImg}
                        src={imageUrl}
                        alt={title || 'Blog post preview'}
                        loading="lazy"
                      />
                    )}
                    <div className={css.blogCardContent}>
                      {tag && <div className={css.blogCardTag}>{tag}</div>}
                      <div className={css.blogCardTitle}>{title}</div>
                      <div className={css.blogCardDesc}>{desc}</div>
                    </div>
                  </div>
                </NamedLink>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </>
  );
};

BlogListing.propTypes = {
  blogs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      _id: PropTypes.string,
      listingId: PropTypes.string,
      title: PropTypes.string,
      label: PropTypes.string,
      image: PropTypes.shape({
        imageUrl: PropTypes.string,
        secure_url: PropTypes.string,
      }),
      content: PropTypes.shape({
        excerpt: PropTypes.string,
        description: PropTypes.string,
      }),
    })
  ),
  fetchBlogsInProgress: PropTypes.bool,
  fetchBlogsError: PropTypes.bool,
};

export default BlogListing;
